<template>
	<div class="nosotros">
		<Navbar />
		<link rel="stylesheet"
			  href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
		<section id="section-presentacion-par" class="padding-generales seccion">
			<div class="container position-texto">
				<div class="row text-center text-md-center d-flex justify-content-center">
					<div class="col-md-10 animate__animated animate__fadeInLeft parrafos-altura-generales">
						<img src="../assets/AusaPar/logoPar.png" class="img-fluid" alt="" />
						<p class="textos subtitulos-intermedios-sec-ajustes light blanco pb-md-3">Nos convertimos en tu aliado legal total para representar y resolver por ti cualquier situación con las unidades de tu flotilla a través de un poder notarial.</p>
					</div>
				</div>
			</div>
			<video class="videos-2" loop autoPlay muted>
				<source src="../assets/AusaPar/looPar.mp4" type="video/webm" playsInline />
				<source src="../assets/AusaPar/looPar.mp4" type="video/mp4" playsInline />
			</video>

		</section>
		<section id="flechas-generales">
			<div class="flecha-down wow animate__animated animate__fadeInDown animate__infinite	infinite animate__slow">
				<img src="../assets/template/images/flecha-abajo.png" alt="" />
			</div>
		</section>
		<div>
			<section>
				<div class="container">
					<div class="row d-flex justify-content-center">
						<div class="col-md-10 text-center">
							<h2 class="textos subtitulos-intermedios azul bold py-4 mayus">¿Qué es AUSA PAR?</h2>
						</div>
					</div>
					<div class="row d-flex justify-content-center py-md-4">
						<div class="col-md-5 text-center">
							<img src="../assets/AusaPar/iconos/par2.png" class="img-fluid pb-3" alt="" />
							<p class="textos parrafos-intermedios negro light">Es un servicio <span class="textos parrafos-intermedios negro bold">independiente a la asistencia legal</span> ofrecida tradicionalmente por las aseguradoras.</p>
						</div>
						<div class="col-md-5 text-center">
							<img src="../assets/AusaPar/iconos/par3.png" class="img-fluid pb-3" alt="" />
							<p class="textos parrafos-intermedios negro light">Se enfoca en la <span class="textos parrafos-intermedios negro bold">representación legal</span> de flotillas, a través de un <span class="textos parrafos-intermedios negro bold">poder notarial.</span></p>
						</div>
					</div>
					<div class="row d-flex justify-content-center py-md-4">
						<div class="col-md-5 text-center">
							<img src="../assets/AusaPar/iconos/par1.png" class="img-fluid pb-3" alt="" />
							<p class="textos parrafos-intermedios negro light">Nuestros abogados, al ser <span class="textos parrafos-intermedios negro bold">apoderados</span>, pueden hacer la representación legal ante la autoridad.</p>
						</div>
						<div class="col-md-5 text-center">
							<img src="../assets/AusaPar/iconos/par4.png" class="img-fluid pb-3" alt="" />
							<p class="textos parrafos-intermedios negro light">Además <span class="textos parrafos-intermedios negro bold">administra fondos</span> para agilizar temas de gestoría como el pago de grúas, multas, corralones y más.</p>
						</div>
					</div>
				</div>
			</section>
		</div>
		<section id="section-descanso-par" class="py-5 bannerPar">
			<div class="container py-4">
				<div class="row">
					<div class="offset-md-6 col-md-6 py-5">
						<h3 class="textos subtitulos-intermedios-ajustes blanco bold">¡DESPREOCÚPATE! SOMOS TU PAR DE CONFIANZA</h3>
					</div>
				</div>
			</div>
		</section>
		<section id="section-slider-par">
			<div class="container py-5">
				<div class="row d-flex justify-content-center">
					<div class="col-md-10 text-center">
						<h2 class="textos subtitulos-intermedios azul bold py-4">BENEFICIOS DE AUSA PAR</h2>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 py-5">
						<agile :initial-slide="0" :autoplay="true" :dots="true">


							<div class="slide">
								<div class="row d-flex justify-content-center py-4">
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px2.png" class="img-fluid iconos" width="10%" alt="" />
										<p class="textos parrafos-intermedios negro light">Evita el traslado del Representante Legal al lugar del siniestro o recuperación.</p>
									</div>
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px1.png" class="img-fluid iconos" width="30%" alt="" />
										<p class="textos parrafos-intermedios negro light">Atiende simultáneamente varios casos a la vez.</p>
									</div>
								</div>
							</div>
							<div class="slide">
								<div class="row d-flex justify-content-center py-4">
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px3.png" class="img-fluid iconos" width="30%" alt="" />
										<p class="textos parrafos-intermedios negro light">Gran ahorro económico en la liberación oportuna de las unidades.</p>
									</div>
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px5.png" class="img-fluid iconos" width="30%" alt="" />
										<p class="textos parrafos-intermedios negro light">Ocupa tu tiempo en lo que más te importa, nosotros nos encargamos.</p>
									</div>
								</div>
							</div>
							<div class="slide">
								<div class="row d-flex justify-content-center py-4">
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px6.png" class="img-fluid iconos" width="30%" alt="" />
										<p class="textos parrafos-intermedios negro light">Cubrimos todo el país con nuestra red de +300 abogados.</p>
									</div>
									<div class="col-md-4 text-center">
										<img src="../assets/AusaPar/iconos-extra/px4.png" class="img-fluid iconos" width="30%" alt="" />
										<p class="textos parrafos-intermedios negro light">Evita trámites largos y tediosos que requieren experiencia.</p>
									</div>
								</div>
							</div>
						</agile>
					</div>
				</div>
			</div>
		</section>

		<SecClientes />
		<Formulario />
		<Footer />
	</div>
</template>

<script src="https://unpkg.com/vue-agile"></script>

<script>
    // @ is an alias to /src
    import Navbar from './shared/Navbar/Navbar.vue';
    import Footer from './shared/footer/Footer.vue';
    import SecClientes from '../views/SecClientes.vue';
    import Formulario from '../views/Formulario.vue';
    import { VueAgile } from 'vue-agile';

    


    export default {
        name: "Nosotros",
        components: {
            Navbar,
            agile: VueAgile,
            Footer,
            SecClientes,
			Formulario

        },
        data() {
            return {
                newItem: "",
            }
		},
		mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
</script>

<style scoped>
.mission-textura {
        background-image: url("../assets/AusaPar/textura.png");
    }  
    .bannerPar{
        background-image: url("../assets/AusaPar/parbanner.png");
    }  

  .nosotros-banner {
        min-height: 650px;
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        background-image: url("../assets/home/banner-nosotros-01.png");
    }
    .ajuste-textos {
        padding-top: 180px;
    }
    .mission-textura {
        background-image: url("../assets/adn/textura.png");
    }      
.clase-simbolo{
    width: 100%;
    max-width: 50px;
}
.clase-images{
    font-size: 25px;
    color: #ffffff; 
}
#section-services{
    background-color: #f8fafd;
}
.estilos-listados-titulo {
    width: 65%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 10px;
    margin-top: 10px;
    border-radius: 20px;
}
.estilos-listados-titulo div {
    padding: 10px;
}
.estilo-caja-collapse{
    width: 50%;
}
.estilos-listados {
    height: 110px;
    width: 60%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 10px;
    margin-top: 10px;
}
.estilos-listados a div {
    padding: 10px;
}
.icon-boton{
    width: 100%;
    max-width: 200px
}
.icon-servicios{
    width: 100%;
    max-width: 45px;
}
#section-banner-services {
    min-height: 650px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
   background-image: url("../assets/servicios/bannerServicios.png");
}
#section-banner-services .ajuste-textos {
    padding-top: 180px;
}
#section-frase{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
@media (max-width: 540px) {
    #section-banner-services {
        min-height: 550px;
        /* background-image: url(../services/banner_mobile.png); */
    }
}


    #section-descanso-par {
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    #section-slider-par .iconos {
        width: 100%;
        max-width: 80px;
        margin: auto;
    }

    #section-slider-par ul {
        padding: 0;
        list-style: none;
    }

        #section-slider-par ul li::before {
            content: "\2022";
            color: #FFDE17;
            font-weight: bold;
            display: inline-block;
            width: 20px;
            margin-left: -1em;
            font-size: 30px;
        }



        #section-slider-par .owl-carousel .owl-nav button.owl-next span {
            display: none;
        }



        #section-slider-par .owl-carousel .owl-nav button.owl-prev span {
            display: none;
        }

    #section-slider-par .owl-dots {
        text-align: center;
    }

    #section-slider-par .owl-dot {
        box-shadow: rgba(50,50,93,0.25) 0px 50px 100px -20px, rgba(0,0,0,0.3) 0px 30px 60px -30px;
    }

    #section-slider-par .owl-theme .owl-dots .owl-dot.active span, #section-slider-par .owl-theme .owl-dots .owl-dot:hover span {
        background: #cd292a !important;
    }

    #section-slider-par .owl-theme .owl-dots .owl-dot span {
        width: 20px;
        height: 20px;
    }

    .errors {
        color: red;
        font-size: 20px;
        padding: 0;
    }

    .exito {
        color: green;
        font-size: 20px;
    }

    .spinn {
        width: 100%;
        max-width: 100px;
        display: inherit;
        margin: auto;
        padding-top: 10px;
    }

    .oculutar {
        display: none;
    }
</style>
